import { z } from "zod";

// Volunteer schema with enhanced address fields - using database field names
export const volunteerSchema = z
  .object({
    active: z.boolean(),
    church: z.string().optional(),
    city: z.string().optional(),
    country: z.string().transform((val) => val || "US"),
    // Area where they live
    customResidenceArea: z.string().optional(),

    email: z.string().email(),

    firstName: z.string().min(1, "First name is required"),

    frequency: z.enum(["immediate", "daily", "weekly"]),

    isSubscribed: z.boolean(),

    lastName: z.string().min(1, "Last name is required"),

    organizationId: z.string(),

    phone: z.string().optional(),
    residenceAreaId: z.string().optional(), // Custom residence area text when "other" is selected
    serviceAreas: z
      .array(z.string())
      .min(1, "At least one service area is required"), // Areas they volunteer in
    state: z.string().optional(),
    streetAddress: z.string().optional(),
    zipCode: z.string().optional(),
  })
  .refine(
    (data) => {
      // Either a residence area must be selected OR custom residence area must be provided
      return (
        // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
        (data.residenceAreaId && data.residenceAreaId.trim().length > 0) ||
        (data.customResidenceArea && data.customResidenceArea.trim().length > 0)
      );
    },
    {
      message: "Please select a residence area or specify a custom area",
      path: ["residenceAreaId"], // This will show the error on the residence area field
    },
  );

// Export types
export type VolunteerFormData = z.infer<typeof volunteerSchema>;
